import { GetterTree } from 'vuex';
import {RootState} from './types';
import {UserState} from '@/store/User/types';
import {User} from 'firebase';
import Vue from 'vue';

/* tslint:disable:no-console */

export const getters: GetterTree<RootState, RootState> = {
    async getUserImgURL({}, currentUser: User): Promise<any> {
        try {
            if (currentUser.uid) {
                return await Vue.prototype.$storage.ref(`user-images/${currentUser.uid}`).getDownloadURL();
            }
        } catch (e) {
            console.log('Error getting file reference:', e);
            return null;
        }
    },

};
